import {
    CheckCheck,
    Cpu,
    Database,
    Eye,
    FileText,
    ListChecks,
    LucideIcon,
    Repeat,
    ScanText,
    Sparkles,
    Table,
    Workflow,
} from 'lucide-react';

export type InfoCard = {
    icon: LucideIcon;
    title: string;
    description: string;
};

/**
 * The jobs we take on - what a client gets.
 * Kept separate from EXTRACTION_APPROACHES, which is how we do it.
 */
export const SERVICES: InfoCard[] = [
    {
        icon: FileText,
        title: 'Digitize documents',
        description: 'PDFs, scans, and other document types become well-organized, readable, and scalable.',
    },
    {
        icon: Table,
        title: 'Extract and reformat information',
        description: 'Pull the data, fields, or cells you need and deliver them in the shape your systems expect.',
    },
    {
        icon: Database,
        title: 'Build databases',
        description: 'Turn scattered documents into one structured, reliable dataset.',
    },
    {
        icon: Repeat,
        title: 'Automate repetitive tasks',
        description:
            'Hand over the document work that currently eats your team’s week and let us develop a workflow, automate, and organize.',
    },
];

export const EXTRACTION_APPROACHES: InfoCard[] = [
    {
        icon: ScanText,
        title: 'Manual Extraction',
        description:
            'Experienced human specialists read, interpret and process your documents — the right call when context, judgment or messy source material is involved.',
    },
    {
        icon: Cpu,
        title: 'Automated Extraction',
        description:
            'Rule-based pipelines handle high-volume, consistently formatted documents automatically.',
    },
    {
        icon: Sparkles,
        title: 'AI-Assisted Extraction',
        description:
            'Models do the first pass and specialists confirm the result - a way of automation, supported by the accuracy of human review.',
    },
    {
        icon: Workflow,
        title: 'Workflow Design',
        description:
            'We build or optimize the process around your project, so repetitive document work stops being a priority and can be processed automatically.',
    },
];

export const QUALITY_CHECKS: InfoCard[] = [
    {
        icon: CheckCheck,
        title: 'Multi-level data verification',
        description: 'Every record passes through more than one set of eyes before it reaches you.',
    },
    {
        icon: Eye,
        title: 'Expert human oversight',
        description: 'Specialists who recognize document types, data discrepancies, and edge cases, which automation cannot settle.',
    },
    {
        icon: ListChecks,
        title: 'Automated validation checks',
        description: 'Automated checks validate rules, totals and formatting across the full dataset, helping ensure consistent, reliable output.',
    },
];

export const PROJECT_NEEDS = [
    'Digitizing documents',
    'Extracting and reformatting information',
    'Building a database',
    'Automating a repetitive task',
    'Something else / not sure yet',
];

export const APPROACH_OPTIONS = [
    'Manual extraction',
    'Automated extraction',
    'AI-assisted extraction',
    'Workflow design',
    'Not sure - advise me',
];
